import { IParseOptions, IStringifyOptions, parse, stringify } from 'qs';

import config from 'data/config';
import { Uuid } from 'types/common';

const encodeParams = (params?: object, options?: IStringifyOptions) => stringify(params, {
  ...options,
  arrayFormat: 'brackets',
  allowDots: true,
  encodeValuesOnly: true,
});

const decodeParams = (params: string, options?: IParseOptions) => parse(params, {
  ...options,
  allowDots: true,
});

const prepareFilterParams = <Values>(values?: Values) => ({ [config.FILTERS_QUERY_PARAM]: values });

const toFull = (path: string) => `${window.location.origin}${path}`;

const toDashboard = (path = '') => `/dashboard${path}`;

const toInvoices = (path = '') => toDashboard(`/transactions${path}`);

const toInvoice = (id: Uuid) => toInvoices(`/${id}`);

const toInvoicePayment = (displayId: string) => `/pay/invoice/${displayId}`;

const toInvoicePaymentFull = (displayId: string) => toFull(toInvoicePayment(displayId));

const toLogin = () => '/login';

const toPasswordReset = () => '/reset-password';

const toPrivacy = () => config.PRIVACY_URL;

const toProfile = () => toDashboard('/profile');

const toRegistration = () => '/register';

const toTerms = () => config.TERMS_URL;

const toWithdrawal = () => toDashboard('/withdrawal');

const url = {
  encodeParams,
  decodeParams,
  prepareFilterParams,

  toDashboard,
  toInvoices,
  toInvoice,
  toInvoicePayment,
  toInvoicePaymentFull,
  toLogin,
  toPasswordReset,
  toPrivacy,
  toProfile,
  toRegistration,
  toTerms,
  toWithdrawal,
};

export default url;
